import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SyllabusService } from '@examdojo/category/v2';
import { first, map } from 'rxjs';
import { CmsUrlParts } from '../cms/cms.model';

export const syllabusRedirectGuard: CanActivateFn = () => {
  const syllabusService = inject(SyllabusService);
  const router = inject(Router);

  return syllabusService.fetchSyllabuses().pipe(
    first(),
    map((syllabuses) => {
      if (!syllabuses.length) {
        return router.createUrlTree([`/${CmsUrlParts.Overview}`]);
      }

      // Get the first syllabus as default (or you could use a more sophisticated logic)
      const defaultSyllabus = syllabuses[0];
      return router.createUrlTree([`/${CmsUrlParts.Syllabus}`, defaultSyllabus.slug, CmsUrlParts.Sources]);
    }),
  );
};
